import { Link } from "react-router-dom";

export const Brand = ({ compact = false }) => (
    <Link to="/" data-testid="brand-link" className="flex items-center gap-2.5 group">
        <span className="grid h-7 w-7 place-items-center rounded-sm bg-blue-950 text-white">
            <span className="font-mono text-[13px] leading-none">K</span>
        </span>
        {!compact && (
            <span className="flex flex-col leading-tight">
                <span className="text-sm font-medium tracking-tight text-slate-900">
                    KATLAS
                </span>
                <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-slate-400">
                    Control Decision Envelope
                </span>
            </span>
        )}
    </Link>
);
